import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ac7e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-[700px]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex justify-center w-full flex-col items-center md:flex-row md:items-start mb-10" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "flex flex-col w-full max-w-[400px] min-w-[300px] ml-0 mt-8 md:ml-8 md:mt-0" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "stepper__subtitle"
}
const _hoisted_9 = { class: "line-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Status", -1))
const _hoisted_11 = { class: "line-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Origin chain", -1))
const _hoisted_13 = { class: "capitalize" }
const _hoisted_14 = { class: "line-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Origin address", -1))
const _hoisted_16 = { class: "line-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Amount", -1))
const _hoisted_18 = { class: "line-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Destination chain", -1))
const _hoisted_20 = { class: "capitalize" }
const _hoisted_21 = { class: "line-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Destination address", -1))
const _hoisted_23 = {
  key: 1,
  class: "text-lg"
}
const _hoisted_24 = {
  key: 2,
  class: "line-item h-[21px]"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-70" }, "Send", -1))
const _hoisted_26 = {
  key: 3,
  class: "line-item h-[21px]"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-70" }, "Receive", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_tag = _resolveComponent("tag")!
  const _component_nft_preview = _resolveComponent("nft-preview")!
  const _component_copy_hash = _resolveComponent("copy-hash")!
  const _component_n_time = _resolveComponent("n-time")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_notification_link = _resolveComponent("notification-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status < _ctx.TxStatus.PROCESSED && _ctx.manualProcess && !_ctx.readyToProcess)
      ? (_openBlock(), _createBlock(_component_n_alert, {
          key: 0,
          type: "warning",
          title: "Important!",
          class: "yellow-alert mb-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Nomad bridge transfers take between 35-55 mins to complete. Return to this page to check the status and submit a transaction to " + _toDisplayString(_ctx.affected ? 'mint your NFT.' : `receive ${_ctx.token.symbol} tokens`), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status < _ctx.TxStatus.PROCESSED && _ctx.manualProcess && _ctx.readyToProcess)
      ? (_openBlock(), _createBlock(_component_n_alert, {
          key: 1,
          type: "info",
          title: "Important!",
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            (_ctx.affected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Your NFT is ready to mint."))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, "Your " + _toDisplayString(_ctx.token.symbol) + " is ready.", 1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.status)
          ? (_openBlock(), _createBlock(_component_tag, {
              key: 0,
              token: _ctx.token,
              affected: _ctx.affected,
              status: _ctx.status,
              "confirm-at": _ctx.confirmAt,
              "dest-net": _ctx.destNet,
              "process-tx": _ctx.processTx,
              onProcess: _ctx.processMessage,
              onReady: _ctx.setReadyToProcess
            }, null, 8, ["token", "affected", "status", "confirm-at", "dest-net", "process-tx", "onProcess", "onReady"]))
          : _createCommentVNode("", true),
        _createVNode(_component_nft_preview, {
          size: 300,
          asset: _ctx.tokenId.id,
          amount: _ctx.rawAmount,
          affected: _ctx.affected,
          inactive: "",
          class: "mt-6"
        }, null, 8, ["asset", "amount", "affected"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, [
          (_ctx.sendTx)
            ? (_openBlock(), _createBlock(_component_copy_hash, {
                key: 0,
                large: "",
                address: _ctx.sendTx,
                class: "address"
              }, null, 8, ["address"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.timeSent && _ctx.timeSent !== 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode(" Transfer initiated on "),
              _createVNode(_component_n_time, { time: _ctx.timeSent }, null, 8, ["time"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_n_divider, { class: "n-div-margin" }),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_ctx.status === _ctx.TxStatus.PROCESSED)
            ? (_openBlock(), _createBlock(_component_n_tag, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("Complete")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_n_tag, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("In progress")
                ]),
                _: 1
              }))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getDisplayName(_ctx.originNet)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", null, _toDisplayString(_ctx.truncateAddr(_ctx.originAddr)), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", null, _toDisplayString(_ctx.amount) + " " + _toDisplayString(_ctx.token.symbol), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getDisplayName(_ctx.destNet)), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, _toDisplayString(_ctx.truncateAddr(_ctx.originAddr)), 1)
        ]),
        _createVNode(_component_n_divider, { class: "n-div-margin" }),
        (_ctx.sendLink || _ctx.receiveLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Transactions"))
          : _createCommentVNode("", true),
        (_ctx.sendLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_notification_link, {
                text: "View Transaction",
                link: _ctx.sendLink,
                class: "mb-2"
              }, null, 8, ["link"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.receiveLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              (_ctx.receiveLink)
                ? (_openBlock(), _createBlock(_component_notification_link, {
                    key: 0,
                    text: "View Transaction",
                    link: _ctx.receiveLink
                  }, null, 8, ["link"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}